module.exports = __webpack_public_path__ + "static/img/lingquan.0e949ce7.png";